import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import { getColor } from "@gc-npm/utils.enums.colors";
import TextInfo from "@gc-npm/components.text";
import CardTemplate from "@/component/cardBanner/card-template";
import PostCard from "@/component/cardBanner/post-card";

const CustomLink = dynamic(() =>
  import("@gc-npm/components.custom-link")
);
const Image = dynamic(() => import("@/component/c-image"));

const extraerTextoSpan = (cadena) => {
  const patron = /<span[^>]*>(.*?)<\/span>/;
  const elementoEncapsulado = patron.test(cadena);
  if (elementoEncapsulado) {
    const resultado = cadena.match(patron);
    if (resultado) {
      return resultado[1];
    } else {
      null;
    }
  }
  return cadena;
};

const comprobarComponentVariation = (taggingInfo, link) => {
  if (taggingInfo && taggingInfo.componentVariation) {
    return taggingInfo.componentVariation;
  } else if (link && link.componentVariation) {
    return link.componentVariation;
  }
  return "all";
};

const Card = (restProps) => {
  const {
    layout,
    backgroundColor,
    skeletonClassName,
    className,
    cardShadow,
    backgroundOpacity,
    setPriority,
    children,
    hash,
    imageAspectRatio,
  } = restProps;
  const titleCusto = restProps["Text-2"]?.text;
  const link = restProps["CustomLink-1"]?.text;
  const backgroundImg = restProps["Image-1"];
  let finalClassName = className;
  // const imgBackground = {
  //   desktop: restProps["Image-1"],
  //   tablet: restProps["Image-tablet"],
  //   mobile: restProps["Image-mobile"],
  // };

  const taggingInfo = restProps.taggingInfo && {
    ...restProps.taggingInfo,
    componentVariation: comprobarComponentVariation(
      restProps.taggingInfo,
      link
    ),
    componentName: "banner-azul-listado",
    componentContent: extraerTextoSpan(titleCusto),
    eventType: "click",
  };

  const computeBackgroundColor = (color) => {
    if (color == "") {
      color = "transparent";
    }
    if (color && typeof color === "string") {
      if (color.charAt(0) === "#") {
        return color;
      } else {
        return getColor(color);
      }
    }
    return getColor(color);
  };

  const cardStyle = {
    backgroundColor: computeBackgroundColor(backgroundColor),
    height: "100%",
  };
  if (cardShadow) {
    finalClassName =
      finalClassName + ` card-shadow--${layout === "dispo-product" ? 1 : 10}`;
  }

  return (
    <div className="card-column" style={{ height: "100%" }}>
      {restProps["Text-0"] && restProps["Text-0"].text && (
        <div className="card-title">
          <TextInfo {...restProps["Text-0"]} cydata="Card TV Text-0" />
        </div>
      )}
      <div
        className={`card layout-${layout} ${finalClassName}`}
        style={cardStyle}
      >
        <>
          {backgroundImg && backgroundImg.src && (
            <div className={`card-backgroundImg-1`}>
              <Image
                hash={hash}
                {...backgroundImg}
                fill
                objectFit={backgroundImg.objectFit || "cover"}
                cydata={`Card Image-1 ${backgroundImg.alt}`}
              />
              {!!backgroundOpacity && <div className="card-img--opacity"></div>}
            </div>
          )}
          <div className="card-container">
            {children && children}
            {!children && <CardTemplate {...restProps} />}
          </div>
          {restProps["CustomLink-1"] &&
            (restProps["CustomLink-1"].href ||
              restProps["CustomLink-1"].onClick) && (
              <CustomLink
                {...restProps["CustomLink-1"]}
                title={restProps["CustomLink-1"].title || ""}
                taggingInfo={taggingInfo}
                className="card-clickable"
                cydata="Card CustomLink-1"
              />
            )}
        </>

        <div className={skeletonClassName} />
      </div>

      {/* Post Card Content Mobile */}
      {restProps["Text-7"] && restProps["Text-7"].text && (
        <PostCard
          {...restProps["Text-7"]}
          skeletonClassName={skeletonClassName}
        />
      )}

      <style jsx>
        {`
          .card-title {
            margin-bottom: 1rem;
          }
        `}
      </style>
    </div>
  );
};

Card.propTypes = {
  layout: PropTypes.string,
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
};

Card.defaultProps = {
  layout: "capta",
  backgroundColor: "transparent",
  className: "",
};

export default Card;
